import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageLayout from "../../component/PageLayout";
import IconAddUser from "../../component/SvgIcon/IconAddUser";
import IconCloseEye from "../../component/SvgIcon/IconCloseEye";
import IconOpenEye from "../../component/SvgIcon/IconOpenEye";
import IconUsers from "../../component/SvgIcon/IconUsers";
import "./style.css";
import api from "../../services";
import { useSwal } from "../../services/SweetAlert";
import { useAuth } from "../../services/AuthContext";

 export default function AddUser() {
  const navigate = useNavigate();
  const { country: authCountry } = useAuth();
  const alert = useSwal(); 
  
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    country: authCountry || "",
    locationId: "",
    userType: "", 
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState([]);
  const [countries, setCountries] = useState([]);
  const [userTypes, setUserTypes] = useState([]);
useEffect(() => {
  async function fetchLocations() {
    try {
      //Change for location api 
      // const res = await api.get("/adduserlocation");
      const res = await api.get("/location");
      if (res.data.success) {
        setLocations(res.data.data);

        // Auto select first location for admin country
        if (authCountry) {
          const firstLocation = res.data.data.find(
            loc => loc.Country === authCountry
          );
          if (firstLocation) {
            setFormData(prev => ({
              ...prev,
              locationId: firstLocation.Id
            }));
          }
        }

        const uniqueCountries = Array.from(
          new Set(res.data.data.map(loc => loc.Country))
        ).map((name, idx) => ({ Id: idx + 1, Name: name }));
        setCountries(uniqueCountries);
      }
    } catch (err) {
      console.error("Error fetching locations:", err);
    }
  }
  fetchLocations();
}, [authCountry]);


useEffect(() => {
  async function fetchUserTypes() {
    try {
      const res = await api.get("/UserType");
      if (res.data.success && Array.isArray(res.data.data)) {
        const types = res.data.data
          .filter(item => !item.UserType.toLowerCase().includes("super")) // remove Super
          .map((item, index) => ({
            Id: index + 1,
            Name: item.UserType,
          }));
        setUserTypes(types);
      }
    } catch (err) {
      console.error("Error fetching user types:", err);
    }
  }
  fetchUserTypes();
}, []);


  const filteredLocations = formData.country
    ? locations.filter(loc => loc.Country === formData.country)
    : [];

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (name === "country") {
      setFormData(prev => ({ ...prev, locationId: "" })); // Reset location if country changes
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
      try {
        const response = await api.post("/adminuserdetils", {
          UserType: "admin", //Hardcoded to get users email for validation. later we can validate logged in user type and pass accordingly
          Country: formData.country
        });
        console.log("response adminuserdetils", response.data.data);
        
        const existingEmails = response.data.data.map(user => user.email.toLowerCase());

        if (existingEmails.includes(formData.email.toLowerCase())) {
          alert("error", "Please use a different email.", "Email Already Exists");
          return; // stop submission
        }
      } catch (err) {
        console.error("Error checking existing emails:", err);
        alert("error","Unable to verify if the email already exists. Please try again.");
        return;
      }

       if (formData.mobile.length < 6) {
        alert("error", "Please enter a valid mobile number.");
        return;
      }

    setLoading(true);
    console.log("Selected Country:", formData.country);
    console.log("Selected Location ID:", formData.locationId);
    const payload = {
       location_id: parseInt(formData.locationId),
      UserName: `${formData.firstName} ${formData.lastName}`.trim(),
      Email: formData.email,
      Mobile: formData.mobile,
      Country: formData.country,
      Password: formData.password,
      UserType: formData.userType,
      Assigned: "null", // Static assignment
    };
  console.log("Payload being sent to API:", payload);
    try {
      const res = await api.post("/web-Add-user", payload);
      console.log("Full API Response:", res.data);

      const message =
        typeof res.data === "string"
          ? res.data
          : res.data?.message || "";

      if (message.includes("User created successfully")) {
        alert("success", "User added successfully!");
        navigate("/user-list");
      } else {
        alert(message || "error", "Failed to add user. Please check input.");
      }
    } catch (err) {
      if (err.response) {
        console.error("API Error Response:", err.response.data);
        const apiMessage = err.response.data?.message || "An error occurred while submitting the form.";
        alert("error", apiMessage);
      } else {
        console.error("Submit error:", err);
        alert("error", "An error occurred while submitting the form.");
      };
    } finally {
      setLoading(false);
    }
};


  return (
    <PageLayout
      url="/user-list"
      secondiconTitle="User List"
      secondicon={<IconUsers />}
      icon={<IconAddUser />}
      pagetitle="Add User"
    >
      <div className="topspace">
        <div className="container-fluid">
          <section className="user-section mb-4">
            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label>First Name <small>*</small></label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                    className="form-control"
                    placeholder="Enter First Name"
                  />
                </div>

                <div className="form-group">
                  <label>Last Name</label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Enter Last Name"
                  />
                </div>

                <div className="form-group">
                  <label>Email Address <small>*</small></label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="form-control"
                    placeholder="Enter Email Address"
                  />
                </div>

                <div className="form-group">
                  <label>Mobile <small>*</small></label>
                  <input
                    type="text"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    required
                    className="form-control"
                    placeholder="Enter Mobile Number"
                  />
                </div>

             <div className="form-group">
                <label>Country <small>*</small></label>
                <select
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  className="form-control"
                  style={{border:"solid 1px #ddd"}}
                  required
                  disabled={!!authCountry}
                >
                  <option value="">Select Country</option>
                  {countries.map(c => (
                    <option key={c.Id} value={c.Name}>{c.Name}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Location <small>*</small></label>
                <select
                  name="locationId"
                  value={formData.locationId}
                  onChange={handleChange}
                  className="form-control"
                  required
                >
                  <option value="">Select Location</option>
                  {filteredLocations.map(loc => (
                    <option key={loc.Id} value={loc.Id}>{loc.Name}</option>
                  ))}
                </select>
              </div>


                <div className="form-group">
                  <label>User Type <small>*</small></label>
                  <select
                    name="userType"
                    value={formData.userType}
                    onChange={handleChange}
                    className="form-control"
                    required
                  >
                    <option value="">Select User Type</option>
                    {userTypes.map(type => (
                      <option key={type.Id} value={type.Name}>{type.Name}</option>
                    ))}
                  </select>
                </div>

                <div className="form-group password-wrapper">
                  <label>Password <small>*</small></label>
                  <div className="password-field" style={{ position: "relative" }}>
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Password"
                      required
                    />
                    <span onClick={() => setShowPassword(!showPassword)} style={{ cursor: "pointer" }}>
                      {showPassword ? <IconOpenEye /> : <IconCloseEye />}
                    </span>
                  </div>
                </div>
              </div>

              <div className="bottombtn w-100 justify-content-center d-flex gap-3 mt-4">
                <Link to="/user-list" className="btn backbtn">Back</Link>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
    </PageLayout>
  );
}
